import React from "react";
import Tabla from "./Tabla";
import Loading from "../../../components/Loading";
import destino_icon from "../../../assets/vw/svg/destinatarios.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import TablaArchivo from "./TablaInactivos";
import Menu from "../../../components/Menu";
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";


class Destinatarios extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataFiltradas: [],
      notificaciones: [],
      filtradasInactivas: [],
      cargando: true,
      searchInput: "",
      option: "destinatarios",
      notificacionesInactivas: [],
      dataOriginal: [],
      modal: {
        active: false,
        message: '',
        success: false
      },
      success: false
    };
  }

  componentDidMount() {
    Promise.all([
      fetch(process.env.REACT_APP_URL_DTO_BACK + "destinatarios?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(process.env.REACT_APP_URL_DTO_BACK + "notificaciones?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
    ])
      .then(([responseBodyDestinatarios, responseBodyNotificaciones]) => {
        const activas = responseBodyDestinatarios.mensaje.filter((notificacion) => {
          return notificacion.activo_2 === 1;
        });
        this.setState({
          cargando: false,
          dataOriginal: responseBodyDestinatarios.mensaje,
          data: activas,
          notificaciones: responseBodyNotificaciones.mensaje,
          success: true
        });
      })
      .catch((errorP) => {
        this.setState({
          cargando: false, modal: {
            active: true,
            message: errorP.message,
            success: false
          },
          success: false
        });
        console.error(errorP.stack || errorP);
      });
  }

  changeOption = (option) => {
    this.setState({ option, filtradasInactivas: [], dataFiltradas: [] });
    if (option === "archivo") {
      this.destinatariosInactivas(this.state.dataOriginal);
    }
  };

  destinatariosInactivas = (data) => {
    const inactivas = data.filter((notificacion) => {
      return notificacion.activo_2 === 0;
    });
    this.setState({ notificacionesInactivas: inactivas });
  }


  handleChange = (event) => {
    if (this.state.option === "archivo") {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearchInactivas();
      });
    } else {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearch();
      });
    }
  };

  globalSearch = () => {
    let { data, searchInput, notificaciones } = this.state;
    if (searchInput && searchInput !== "") {
      let dataFiltradas = data.filter((value) => {
        let noti = notificaciones.filter(
          (x) => x.idNotificacion === value.idNotificacion_2
        );
        return (
          value.alias_2.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.alias_2.toString().includes(searchInput.toLowerCase()) ||
          noti[0].accion.includes(searchInput.toLowerCase())
        );
      });
      this.setState({ dataFiltradas });
    } else {
      let dataFiltradas = [];
      this.setState({ dataFiltradas });
    }
  };

  globalSearchInactivas = () => {
    let { notificacionesInactivas, searchInput, notificaciones } = this.state;
    if (searchInput && searchInput !== "") {
      let filtradasInactivas = notificacionesInactivas.filter((value) => {
        let noti = notificaciones.filter(
          (x) => x.idNotificacion === value.idNotificacion_2
        );
        return (
          value.alias_2.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.alias_2.toString().includes(searchInput.toLowerCase()) ||
          noti[0].accion.includes(searchInput.toLowerCase())
        );
      });
      this.setState({ filtradasInactivas });
    } else {
      let filtradasInactivas = [];
      this.setState({ filtradasInactivas });
    }
  };

  render() {
    return (
      <>
        <Menu />
        <Modal
          modalInfo={this.state.modal}
          setMostrarModal={(data) => {
            this.setState({ modal: data });
          }}
        />
        {
          this.state.cargando && <Loading />
        }
        <div className={`navegacion destinatarios-section`}>
          {this.state.success ? (
            <>
              <div className=" posicionMenu">
                <ul className="d-flex flex-row px-0 my-0">
                  <li
                    className="opcion-ruta"
                    onClick={() => this.changeOption("destinatarios")}
                  >
                    <div
                      className={`nav-link nav-link-title active ps-0 ${this.state.option === "destinatarios"
                          ? " active border_menu"
                          : ""
                        }`}
                    >
                      <img
                        src={destino_icon}
                        alt="destinatarios"
                        className="icono-menu me-3"
                      />
                      <span className={"nav-link-title-show--mobile"} style={{ marginRight: '5px' }}>Centro de</span>
                      <span className={"nav-link-title-one-word--mobile"}>destinatarios</span>
                    </div>
                  </li>
                  <li
                    className="opcion-ruta"
                    onClick={() => this.changeOption("archivo")}
                  >
                    <div
                      className={`nav-link active ps-0  ${this.state.option === "archivo"
                          ? " active border_menu"
                          : ""
                        }`}
                    >
                      <img src={ARCH} alt="archivo" className="icono-menu me-3" />
                      Archivo
                    </div>
                  </li>
                </ul>
              </div>

              <div className="row border_vw pt-4 ms-0 mx-0">
                <div className="col-12 p-0 contenedor-table">
                  {this.state.option === "archivo" ? (
                    <TablaArchivo
                      data={
                        this.state.filtradasInactivas &&
                          this.state.filtradasInactivas.length
                          ? this.state.filtradasInactivas
                          : this.state.notificacionesInactivas
                      }
                      notificaciones={this.state.notificaciones}
                      servicio={this.props.servicio}
                      marca={this.props.marca}
                      marcaNombre={this.state.marca}
                      handleChange={this.handleChange}
                    ></TablaArchivo>
                  ) : (
                    <Tabla
                      data={
                        this.state.dataFiltradas &&
                          this.state.dataFiltradas.length
                          ? this.state.dataFiltradas
                          : this.state.data
                      }
                      notificaciones={this.state.notificaciones}
                      servicio={this.props.servicio}
                      marca={this.props.marca}
                      marcaNombre={this.state.marca}
                      handleChange={this.handleChange}
                    ></Tabla>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              {
                !this.state.cargando && <NoInfoScreen />
              }
            </>
          )
          }
        </div>
      </>
    );
  }
}

export default Destinatarios;
